import { useEffect, useState } from 'react';

import {
  Button,
  ListItem,
  ListItemText,
  Avatar,
  Slide,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import RefreshIcon from '@material-ui/icons/Refresh';
import compareVersions from 'compare-versions';

import * as socketEvents from 'constants/socketEvents';
import socket from 'services/socket';

const appVersion = process.env.REACT_APP_VERSION || '';

const useStyles = makeStyles(({ palette, spacing, zIndex }) => ({
  button: {
    zIndex: zIndex.drawer + 1,
    padding: spacing(1, 3),
    position: 'absolute',
    bottom: spacing(4),
    left: spacing(12),
  },
  icon: {
    padding: spacing(3),
    color: palette.primary.main,
    backgroundColor: palette.common.white,
  },
}));

export default function ButtonAtualizarVersao() {
  const classes = useStyles();
  const [showButton, setShowButton] = useState(false);
  const [currentVersion, setCurrentVersion] = useState(appVersion);

  useEffect(() => {
    const handler = (data: { versao: string }) => {
      setCurrentVersion(data.versao);
    };

    socket.on(socketEvents.ON_CURRENT_VERSION, handler);

    return () => {
      socket.off(socketEvents.ON_CURRENT_VERSION, handler);
    };
  }, []);

  useEffect(() => {
    const isNewVersion = compareVersions(currentVersion, appVersion) === 1;
    setShowButton(isNewVersion);
  }, [currentVersion]);

  return (
    <Slide direction="up" in={showButton} mountOnEnter unmountOnExit>
      <Button
        color="primary"
        variant="contained"
        className={classes.button}
        onClick={() => window.location.reload()}
        startIcon={
          <Avatar className={classes.icon}>
            <RefreshIcon />
          </Avatar>
        }
      >
        <ListItem>
          <ListItemText
            primary="Atualização disponível"
            primaryTypographyProps={{ variant: 'body2' }}
            secondary="Clique para atualizar o Tarelo"
            secondaryTypographyProps={{ color: 'inherit', variant: 'caption' }}
          />
        </ListItem>
      </Button>
    </Slide>
  );
}
